import constants from 'constants';

import {
  PERFORM_LOGOUT,
  UPDATE_USER,
  ADD_ADMIN_USERS,
  SET_EDIT_USER,
  ADD_ADMIN_DASHBOARD_USERS,
  SET_PROFILE_CONFIRMATION,
  ADD_ADMIN_USRES_WEBINARS
} from 'constants/actions.js';

const {
  ZOOM_INFO_STATUS
} = constants;

const users = (users = {
    user: {},
    showProfileConfirmation: ZOOM_INFO_STATUS.closed,
    adminUsers: {
      values: [],
      page: 1,
      count: 0,
      total_pages: 0,
      query: {
        order: {
          created_at: 'desc'
        }
      }
    },
    adminWebinarRegisteredUsers: [],
    tmp: {},
    statistics: {
      registered_users: 0,
      logged_in_users: 0,
      user_type_users: 0,
      hospital_users: 0,
      county_users: 0,
      total_users: 0
    }
  }, {
    type,
    payload,
    page,
    pages
  }) => {
  switch(type) {
    case UPDATE_USER:
      return { ...users,  ...{ user: payload.user } }
    case ADD_ADMIN_USERS:
      return {
        ...users,
        ...{
          adminUsers: {
            values: payload.values,
            count: payload.count,
            page: payload.page,
            total_pages: payload.total_pages,
            query: payload.query
          }
        }
      }
    case PERFORM_LOGOUT:
      return {
        ...users,
        ...{ user: {} }
      }
    case SET_EDIT_USER:
      return {
        ...users,
        ...{
          tmp: payload.user
        }
      }
    case ADD_ADMIN_DASHBOARD_USERS:
      return {
        ...users,
        ...{
            statistics: {
              ...users.statistics,
              ...payload.statistics
            }
        }
      }
    case SET_PROFILE_CONFIRMATION:
      return {
        ...users,
        showProfileConfirmation: payload.showProfileConfirmation
      }
    case ADD_ADMIN_USRES_WEBINARS:
      return {
        ...users,
        adminWebinarRegisteredUsers: payload.values
      }
    default: return users
  }
}
export { users };



/** WEBPACK FOOTER **
 ** ./src/reducers/users.js
 **/